import { LegalPieceMacroType } from "@/contexts/MessagesContext";
import { buildSkillStep, createUploadFileField } from "@/core/skillForms/builder";
import { FileTypes } from "@/core/skills/types";

export const createOtherTypeOfPieceSkillStep4Response = buildSkillStep({
  title: "Provas",
  description: "Anexe os documentos que serão utilizados como provas para fornecer o contexto do seu caso à IA:",
  fields: [
    createUploadFileField({
      name: "evidence_documents",
      required: false,
      ui: {
        label: "Anexar provas",
        description:
          "Anexe os arquivos referentes às provas, que serão utilizados para aprimorar a argumentação do caso. \n**Recomendamos organizar cada prova em arquivos separados, em vez de consolidá-las em um único documento.**",
        enableMarkdownInDescription: true,
        options: {
          multiple: true,
          accept: [FileTypes.PNG, FileTypes.JPEG, FileTypes.TIFF, FileTypes.PDF],
        },
      },
    }),
  ],
  submitButtonText: "Escrever peça",
  condition: {
    value: LegalPieceMacroType.RESPONSE,
    field: "legal_piece_macro_type",
  },
});
